import { gql } from "@apollo/client";

export const DISMISS_PREQUALIFICATION_BANNER = gql`
  mutation DismissPrequalificationBanner {
    dismissPrequalificationBanner
  }
`;
